import { searchMemories, listMemories } from "@/helpers/apis";
import useTeammates from "@/pages/mcp/useTeammates";
import { useMemo } from "react";
import { useQuery } from '@tanstack/react-query';
import { Memory } from "./types";

const useMemories = ({ debouncedSearch }: { debouncedSearch?: string }) => {
  const { data: datamates, isLoading: datamatesLoading } = useTeammates();

  const datamateIds = useMemo(
    () =>
      datamates
        ?.map(datamate => (datamate.id ? datamate.id : undefined))
        .filter((id): id is string => Boolean(id)) || [],
    [datamates]
  );

  const {
    data: memories = [],
    isFetching,
    isFetched,
    error,
  } = useQuery<Memory[]>({
    queryKey: ["memories", debouncedSearch, datamateIds],
    queryFn: async () => {
      const response = debouncedSearch
        ? await searchMemories(debouncedSearch, { datamate_id: datamateIds })
        : await listMemories({ datamate_id: datamateIds });
      return response || [];
    },
    enabled: !datamatesLoading && datamateIds.length > 0,
  });

  return {
    memories,
    datamates,
    isFetching: isFetching || datamatesLoading,
    datamatesLoading,
    error,
    isFetched,
  };
};

export default useMemories;
